import { reloadAuthorized } from './Authorized';
import type { Route } from '@/models/connect';
import pathRegexp from 'path-to-regexp';

/**
 * props.route.routes
 * @param router [{}]
 * @param pathname string
 */
export const getAuthorityFromRouter = <T extends Route>(
  router: T[] = [],
  pathname: string,
): T | undefined => {
  const authority = router.find(
    ({ routes, path = '/', target = '_self' }) =>
      (path && target !== '_blank' && pathRegexp(path).exec(pathname)) ||
      (routes && getAuthorityFromRouter(routes, pathname)),
  );
  if (authority) return authority;
  return undefined;
};

export const getRouteAuthority = (path: string, routeData: Route[]) => {
  let authorities: string[] | string | undefined;
  routeData.forEach((route) => {
    // match prefix
    if (pathRegexp(`${route.path}/(.*)`).test(`${path}/`)) {
      if (route.authority) {
        authorities = route.authority;
      }
      // exact match
      if (route.path === path) {
        authorities = route.authority || authorities;
      }
      // get children authority recursively
      if (route.routes) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        authorities = getRouteAuthority(path, route.routes) || authorities;
      }
    }
  });
  return authorities;
};

// use localStorage to store the authority info, which might be sent from server in actual project.
export function getAuthority(str?: string): string | string[] {
  const authorityString =
    typeof str === 'undefined' && localStorage ? localStorage.getItem('crm-authority') : str;
  // authorityString could be admin, "admin", ["admin"]
  let authority;
  try {
    if (authorityString) {
      authority = JSON.parse(authorityString);
    }
  } catch (e) {
    authority = authorityString;
  }
  if (typeof authority === 'string') {
    return [authority];
  }
  return authority;
}

export function setAuthority(authority: string | string[]): void {
  const proAuthority = typeof authority === 'string' ? [authority] : authority;
  localStorage.setItem('crm-authority', JSON.stringify(proAuthority));
  // auto reload
  reloadAuthorized();
}

export function isGroup(groups: string[]): boolean {
  const currentAuth = getAuthority();
  if (!currentAuth?.length || currentAuth[0] === '') {
    return false;
  }
  return currentAuth.length + groups.length > [...new Set([...currentAuth, ...groups])].length;
}

export function isAdmin() {
  return isGroup(['Admin']);
}

export function isAE() {
  return isGroup(['Madhouse', 'Account Executive', 'Tomato Account Executive']);
}

export function isMadhouse() {
  return isGroup(['Madhouse']);
}

// AE()
export function isAExe() {
  return isGroup(['Account Executive', 'Tomato Account Executive']);
}

// 运营
export function isOD() {
  return isGroup(['Operation Department']);
}

// 游戏运营
export function isGOD() {
  return isGroup(['Game Operation Department']);
}

// BV_内控
export function isBVControl() {
  return isGroup(['BV_control']);
}

// mad_内控
export function isMadControl() {
  return isGroup(['mad_control']);
}

// tomato_内控
export function isToControl() {
  return isGroup(['tomato_control']);
}

// 内控
export function isControl() {
  return isGroup(['BV_control', 'mad_control', 'tomato_control']);
}
